import { DealProposals } from '../sidebarSections'
import { DealsByCompanies } from 'components/common/DealsByCompanies'
import { Sidebar, If } from 'components/ideal-core-ui'
import { Tasks } from 'components/common/Tasks'
import s from '../ProposalContainer.scss'

const ProposalSidebar = ({
  proposal,
  proposalTasks,
  toggleTasksTab,
  showScheduleTaskModal,
  markTaskAsDone,
  markTaskAsNotDone,
  dealProposals,
  companyDeals
}) => {
  return (
    <Sidebar
      className="sidebar-global proposal"
      title=""
      sidebarType="proposalSidebar"
      sections={[
        {
          title: 'Upcoming Tasks Related to this Proposal',
          content: (
            <If condition={proposal.id}>
              <Tasks
                key="0"
                onMountCallback={toggleTasksTab}
                className={s.sidebarTasks}
                showScheduleTaskModal={showScheduleTaskModal}
                tasks={proposalTasks}
                markAsDone={markTaskAsDone}
                markAsNotDone={markTaskAsNotDone}
              />
            </If>
          )
        },
        {
          title: 'Other Proposals for this Opportunity',
          condition: dealProposals.length,
          content: <DealProposals proposals={dealProposals} />
        },
        {
          title: 'Other Opportunities with this Company',
          condition: companyDeals,
          content: <DealsByCompanies dealsByCompany={[companyDeals]} />
        }
      ]}
    />
  )
}

export default ProposalSidebar
